import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  AppBar,
  Box,
  Container,
  IconButton,
  Paper,
  Toolbar,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const RefundPolicy = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <IconButton edge="start" onClick={handleBack}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 1 }}>
            Refund and Return Policy
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={2} sx={{ p: 3 }}>
          {/* <Typography
            variant="body1"
            component="div"
            sx={{ whiteSpace: "pre-line" }}
          >
            Refund and Return Policy Thank you for choosing RAJDHANI RETAIL We
            want you to be completely satisfied with your purchase. Our policy
            lasts 30 days. If 30 days have gone by since your purchase,
            unfortunately, we can’t offer you a refund or exchange. Due to the
            nature of our products, we have the following return and refund
            policy: Non-Returnable Items * Once your order is shipped, it cannot
            be canceled or returned. This applies to all RAJDHANI RETAIL
            products, * Replacement will deliver in 5-6 working days. * Refund
            will be credited with in 5-7 working days. * Opened or used products
            cannot be returned or refunded. Incorrect or Damaged Items * If you
            receive an incorrect or damaged item, please contact us within 48
            hours of receiving your order. We will be happy to investigate and
            offer a replacement or a full refund. * To report an incorrect or
            damaged item, please email us at team cheerag@rajdhaniretail.in with
            your order number, a brief description of the issue, and any
            relevant photos. General Information * We reserve the right to deny
            any return or refund request that does not comply with this policy.
            * Original shipping costs are non-refundable. * To complete your
            return, we require a receipt or proof of purchase. * Please do not
            send your purchase back to the manufacturer. Additional
            non-returnable items * Products There are certain situations where
            only partial refunds are granted: (if applicable) * Products with
            obvious signs of use * Any item not in its original condition is
            damaged or missing parts for reasons not due to our error. * Any
            item that was purchased over 30 days ago. We appreciate your
            understanding and cooperation. If you have any questions about our
            return and refund policy, please do not hesitate to contact us.
          </Typography> */}
          <div>
            <h1 className="text-2xl font-bold">Refund and Return Policy</h1>
            <p>
              Thank you for choosing <strong>RAJDHANI RETAIL</strong>. We want
              you to be completely satisfied with your purchase. Our policy
              lasts 30 days. If 30 days have gone by since your purchase,
              unfortunately, we can’t offer you a refund or exchange.
            </p>

            <h2>
              Due to the nature of our products, we have the following return
              and refund policy:
            </h2>

            <h3>Non-Returnable Items</h3>
            <ul>
              <li>
                Once your order is shipped, it cannot be canceled or returned.
                This applies to all RAJDHANI RETAIL products.
              </li>
              <li>Replacement will deliver in 5-6 working days.</li>
              <li>Refund will be credited within 5-7 working days.</li>
              <li>Opened or used products cannot be returned or refunded.</li>
            </ul>

            <h3>Incorrect or Damaged Items</h3>
            <ul>
              <li>
                If you receive an incorrect or damaged item, please contact us
                within 48 hours of receiving your order. We will be happy to
                investigate and offer a replacement or a full refund.
              </li>
              <li>
                To report an incorrect or damaged item, please email us at{" "}
                <a href="mailto:cheerag@rajdhaniretail.in">
                  cheerag@rajdhaniretail.in
                </a>{" "}
                with your order number, a brief description of the issue, and
                any relevant photos.
              </li>
            </ul>

            <h3>General Information</h3>
            <ul>
              <li>
                We reserve the right to deny any return or refund request that
                does not comply with this policy.
              </li>
              <li>Original shipping costs are non-refundable.</li>
              <li>
                To complete your return, we require a receipt or proof of
                purchase.
              </li>
              <li>
                Please do not send your purchase back to the manufacturer.
              </li>
            </ul>

            <h3>Additional Non-Returnable Items</h3>
            <p>
              There are certain situations where only partial refunds are
              granted (if applicable):
            </p>
            <ul>
              <li>Products with obvious signs of use.</li>
              <li>
                Any item not in its original condition is damaged or missing
                parts for reasons not due to our error.
              </li>
              <li>Any item that was purchased over 30 days ago.</li>
            </ul>

            <p>
              We appreciate your understanding and cooperation. If you have any
              questions about our return and refund policy, please do not
              hesitate to contact us.
            </p>
            <p>Return will be considered withn 24 hours</p>
          </div>
        </Paper>
      </Container>
    </Box>
  );
};

export default RefundPolicy;
